<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加新推送</el-button
    >
    <el-dialog
      title="添加推送"
      width="1000px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
    >
      <el-form
        label-width="140px"
        :model="tradePair"
        :rules="rules"
        ref="tradePairForm"
      >
        <el-form-item label="推送平台：" prop="stage">
          <el-select v-model="stage" placeholder="请选择">
            <el-option
              v-for="item in stays"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推送标题：" prop="title">
          <el-input v-model="tradePair.title"></el-input>
        </el-form-item>
        <el-form-item label="通知内容：" prop="content">
          <el-input type="textarea" v-model="tradePair.content"></el-input>
        </el-form-item>
        <el-form-item label="内部跳转页面：" prop="url">
          <el-select v-model="tradePair.url" placeholder="请选择">
            <el-option value="">请选择</el-option>
            <el-option
              v-for="item in urllist"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推送目标：" prop="status">
          <el-select v-model="tradePair.status" placeholder="请选择">
            <el-option
              v-for="item in goals"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="目标ID："
          prop="account"
          v-if="tradePair.status == 1"
        >
          <el-input
            type="textarea"
            v-model="tradePair.account"
            placeholder="多个ID请用英文的;隔开"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('tradePairForm')"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'CreateTradePair',
  data() {
    return {
      dialogVisible: false,
      tradePair: {},
      stage: '',
      stays: [
        { value: '1', label: 'IOS' },
        { value: '2', label: 'Android' },
        { value: '3', label: 'IOS & Android' }
      ],
      goals: [{ value: '3', label: '全部' }, { value: '1', label: '部分' }],
      urllist: [
        { value: 'fbsex://purchase', label: '申购主页' },
        { value: 'fbsex://fivepurchase', label: '五折专场主页' },
        { value: 'fbsex://fbsIEO', label: '抢购主页' },
        // { value: 'fbsex://league', label: '笑傲江湖主页' },
        { value: 'fbsex://c2c', label: 'C2C主页' },
        { value: 'fbsex://wallet', label: '钱包主页' }
      ],
      rules: {
        title: [{ required: true, message: '请输入推送标题' }],
        content: [{ required: true, message: '请输入推送内容' }]
      }
    };
  },
  computed: {},
  methods: {
    ...mapActions('pushsetting', ['createand', 'creatios']),
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.stage == 1) {
            this.creatios(this.tradePair).then(() => {
              this.$message.success('IOS推送添加成功！');
              this.dialogVisible = false;
              this.$emit('refresh', { page: 1 });
            });
          } else if (this.stage == 2) {
            this.createand(this.tradePair).then(() => {
              this.$message.success('Andriod添加成功！');
              this.dialogVisible = false;
              this.$emit('refresh', { page: 1 });
            });
          } else {
            this.creatios(this.tradePair).then(() => {
              this.createand(this.tradePair).then(() => {
                this.$message.success('添加成功！');
                this.dialogVisible = false;
                this.$emit('refresh', { page: 1 });
              });
            });
          }
        }
      });
    },
    closeDialog() {
      this.tradePair = {};
      this.$refs['tradePairForm'].resetFields();
    }
  }
};
</script>

<style lang="less" scoped></style>
